import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid'; // Import DataGrid
import { useEffect, useState } from "react";
import { legalTeamApi } from '../../api/api';

const LegalTeamApproveProperties = () => {
  const [loading, setLoading] = useState(true);  // Track loading state
  const [data, setData] = useState([]);  // Initialize investData as an empty array
  const navigate = useNavigate();



  // Fetch investor data
  useEffect(() => {
    const fetchInvestData = async () => {
      setLoading(true);  // Set loading to true initially
      try {
        const response = await legalTeamApi.getLegalTeamApprovedProperties();
  

        // Check if the response data is an array
        if (Array.isArray(response.data)) {
          setData(response.data);  // Set data if it's an array
        } else {
          console.error('API response is not an array');
          setData([]);  // Set an empty array if response is not as expected
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setData([]);  // If error, set empty array
      } finally {
        setLoading(false);  // Stop loading after the fetch attempt (whether successful or not)
      }
    };
    fetchInvestData();
  }, []);

  // Safely format data: Ensure investData is always an array
  const formattedData = Array.isArray(data) ? data.map(item => ({
    id: item.Pid,  // Map "ID" to "id" for the DataGrid
    Legalteam_membername: item.legalteam_name,
    PropertyName:item.PropertyName,
    PhoneNumber: item.MobileNumber,
    Address:item.Address,
    City:item.City,
    Email: item.email,
    Status:item.status
  })) : [];  // Default to an empty array if the data is not an array

  function capitalizeName(name) {
  // Check if the name is falsy (null, undefined, empty string, etc.)
  if (!name) {
    return ''; // Return an empty string if name is null, undefined, or empty
  }

  // Split the name by spaces, capitalize each word, and join them back
  return name.split(' ').map(word => {
    // Capitalize the first character and lowercase the rest of each word
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(' ');
}
  // Columns for DataGrid
  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "Legalteam_membername", headerName: "Legalteam_membername", width: 150,
      renderCell: (params) => <span>{capitalizeName(params.value)}</span>
    },
   {
  field: "PropertyName",
  headerName: "Property Name",
  width: 200,
  renderCell: (params) => (
    <span
      style={{ color: "blue", cursor: "pointer" }}
      onClick={() => navigate(`/property/viewProperty?propertyId=${params.row.id}`)}
    >
      {params.value}
    </span>
  )
},
    {field:"Address" , headerName:"Address" , width:150},
    {field:"City" , headerName:"City" , width:150},
    { field: "PhoneNumber", headerName: "Phone Number", width: 150 },
    { field: "Email", headerName: "Email", width: 220 },
    {field:"Status" , headerName:"Status" , width:100}
  ];
   
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 4, px: 2 }}>
      <div className="dashboard section__space__bottom">
        <Box sx={{ flexGrow: 1 }} style={{ border: '2px solid lightgray', borderRadius: '5px' }}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <h1 style={{ margin: '20px 20px', color: '#13216e', fontWeight: '600', fontSize: '20px' }}>Investor</h1>
            </Grid>
            <Box>
              <Typography
                to="/property"
                style={{ textDecoration: "none", color: "#4e0dff", fontSize: "16px", margin: '34px 0 0 90px' }}
              >
                Total Number of Properties: {formattedData.length}
              </Typography>
            </Box>
          </Grid>
        </Box>

          <div style={{ height: 400, width: '150vh' }}>
            <DataGrid
              rows={formattedData}  // Use formatted data
              columns={columns}  // Define columns
              pageSize={5}
              rowsPerPageOptions={[5, 10, 25]}
              disableSelectionOnClick
              autoHeight={false}
            />
          </div>
      
      </div>
    </Box>
  );
};

export default LegalTeamApproveProperties;
